import React, { useCallback, useState } from "react";
import SelectBox from "../../../components/SelectBox";
import useAppContext from "../../../utils/Reducers";
import moment from "moment";

const SearchBar = (props) => {
  // SerachBar 기본 필드

  const {
    store: { userInfo },
  } = useAppContext();

  const handleChangeField = useCallback((event) => {
    const { name, value } = event.target;
    //console.log("name === " + name + " || value === " + value);
    if (name === "schPlantCd" && value === "") {
      props.setPrimaryParameters({
        ...props.primaryParameters,
        [name]: value,
        ["schScrapAreaCd"]: "",
      });
    } else {
      props.setPrimaryParameters({ ...props.primaryParameters, [name]: value });
    }
  });

  return (
    <>
      <div className="searchdata">
        <ul>
          <li className="date">
            <div className="divide40">
              <font color="grey">⦁</font> 입고일자
            </div>
            <div className="flex50">
              <input
                type="date"
                name="schSinspDt"
                id="schSinspDt"
                onChange={handleChangeField}
                className="datainput"
                value={props.primaryParameters.schSinspDt}
              />
              &nbsp;~&nbsp;
              <input
                type="date"
                name="schEinspDt"
                id="schEinspDt"
                onChange={handleChangeField}
                className="datainput"
                value={props.primaryParameters.schEinspDt}
              />
            </div>
          </li>
          <li style={{ width: "350px" }}>
            <div className="divide50">
              <font color="grey">⦁</font> 사업장구분
            </div>
            <SelectBox
              mastCd="PLANT_CD"
              id="schPlantCd"
              name="schPlantCd"
              topSelected="전체"
              attr5="Y"
              data_value="attr3"
              onChange={handleChangeField}
              value={props.primaryParameters.schPlantCd}
              className="datainput"
              style={{ width: "200px" }}
            />
          </li>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 공급업체
            </div>
            <input
              type="text"
              name="schVndrNm"
              onChange={handleChangeField}
              className="datainput"
              value={props.primaryParameters.schVndrNm}
            />
          </li>
        </ul>
      </div>
    </>
  );
};

export default React.memo(SearchBar);
